<template>
<div class="hit-container">
<h1 class="hit-html-h1">{{ $t('message.terms') }}</h1>
<div class="hit-form-group" v-html="terms" />
</div>
</template>
<script>
import de from 'raw-loader!@shared/language/terms/de_DE.txt'

var terms = {
  'de': ''
}

terms.de = de

export default{
  name: 'terms',

  data () {
    var lang = this.$route.params.lang

    if (typeof terms[lang] !== 'string') { lang = 'de' }

    return {
      terms: this.$nl2br(terms[lang])
    }
  }
}
</script>

<style scoped>

</style>
